import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/logo/vz-logo-white.svg")